import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import Api from "../services/api";
import { toastNotification } from "../services/notification-service";

interface WithdrawalsState {
  withdrawalList: any;
  withdrawalParam: any;
  isLoading: any;
}

const initialState: WithdrawalsState = {
  withdrawalList: {},
  withdrawalParam: {},
  isLoading: {},
};

const withdrawalSlice = createSlice({
  name: "withdrawal",
  initialState,
  reducers: {
    setUpdatedWithdrawal: (state, { payload }: PayloadAction<any>) => {
  if (state.withdrawalList.data) {
    state.withdrawalList.data = state.withdrawalList.data.map(item => 
      item.id === payload.id ? { ...item, ...payload } : item
    );
  }
},
    setWithdrawalList: (state, { payload }: PayloadAction<any>) => {
      state.withdrawalList = payload;
    },
    setDeletedWithdrawal: (state, { payload }: PayloadAction<any>) => {
      state.withdrawalList.data = state.withdrawalList.data.filter(
        (item) => item.id !== payload
      );
    },
    setWithdrawalParams: (state, { payload }: PayloadAction<any>) => {
      state.withdrawalParam = payload;
    },
    setLoader: (state, { payload }: PayloadAction<any>) => {
      state.isLoading = { ...state.isLoading, ...payload };
    },
    reset: () => initialState,
  },
});

export const {
  setWithdrawalList,
  setDeletedWithdrawal,
  setWithdrawalParams,
  setLoader,
  setUpdatedWithdrawal,
  reset,
} = withdrawalSlice.actions;

export default withdrawalSlice.reducer;

export const fetchWithdrawals = (data: any, noload?: boolean) => async (dispatch: any) => {
  dispatch(setLoader({ withdrawals: noload ? false : true }));
  const res = await Api.withdrawals(data);
  dispatch(setLoader({ withdrawals: false }));
  if (res?.status === 200) {
    dispatch(setWithdrawalList(res?.data));
  }
};

export const deleteWithdrawal = (id: number) => async (dispatch: any) => {
  dispatch(setLoader({ deleteWithdrawal: true }));
  const res = await Api.deleteWithdrawal(id);
  dispatch(setLoader({ deleteWithdrawal: false }));
  if (res?.status === 200) {
    dispatch(setDeletedWithdrawal(id));
    toastNotification({ status: "success", message: "Withdrawal deleted successfully!" });
  }
};

export const updateWithdrawal = (id: number, data: any) => async (dispatch: any) => {
  dispatch(setLoader({ updateWithdrawal: true }));
  const res = await Api.updateWithdrawal(id, data);
  dispatch(setLoader({ updateWithdrawal: false }));
  if (res?.status === 200) {
    dispatch(setUpdatedWithdrawal(res.data));
    toastNotification({ status: "success", message: "Withdrawal updated successfully!" });
    return true;
  }
  return false;
};
